import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/aocx',
  component: Layout,
  name: 'Aocx',
  meta: {
    title: 'AOCX 管理',
    icon: 'i-ant-design:robot-outlined',
    auth: [
      'crae:agent:management:list',
      'crae:agent:system-variable:list',
      'crae:agent:model:list',
      'crae:agent:review:list',
      'crae:agent:user:list',
      'crae:agent:creator-application:list',
    ],
  },
  children: [
    {
      path: 'management',
      name: 'CraeAgentManagementIndex',
      component: () => import('@/views/aocx/management/index.vue'),
      meta: { title: '智能体管理', icon: 'i-ant-design:robot-outlined', auth: 'crae:agent:management:list' },
    },
    {
      path: 'management/detail/:id',
      name: 'CraeAgentManagementDetail',
      component: () => import('@/views/aocx/management/detail.vue'),
      meta: { title: '智能体管理详情', auth: 'crae:agent:management:list', menu: false, activeMenu: '/aocx/management', tabMerge: 'activeMenu' },
    },
    {
      path: 'management/:id/consumption-ledger',
      name: 'CraeAgentManagementConsumptionLedger',
      component: () => import('@/views/aocx/management/consumption-ledger.vue'),
      meta: { title: '智能体积分消耗', auth: 'crae:agent:management:list', menu: false, activeMenu: '/aocx/management', tabMerge: 'activeMenu' },
    },
    {
      path: 'system-variable',
      name: 'CraeAgentSystemVariableIndex',
      component: () => import('@/views/aocx/system-variable/index.vue'),
      meta: { title: '环境变量管理', icon: 'i-ant-design:setting-outlined', auth: 'crae:agent:system-variable:list' },
    },
    {
      path: 'model-management',
      name: 'CraeAgentModelManagementIndex',
      component: () => import('@/views/aocx/model-management/index.vue'),
      meta: { title: '模型管理', icon: 'i-ant-design:api-outlined', auth: 'crae:agent:model:list' },
    },
    {
      path: 'image-model-management',
      name: 'CraeAgentImageModelManagementIndex',
      component: () => import('@/views/aocx/image-model-management/index.vue'),
      meta: { title: '生图模型', icon: 'i-ant-design:picture-outlined', auth: 'crae:agent:model:list' },
    },
    {
      path: 'review',
      name: 'CraeAgentReviewIndex',
      component: () => import('@/views/aocx/review/index.vue'),
      meta: { title: '智能体审核', icon: 'i-ant-design:audit-outlined', auth: 'crae:agent:review:list' },
    },
    {
      path: 'review/detail/:id',
      name: 'CraeAgentReviewDetail',
      component: () => import('@/views/aocx/review/detail.vue'),
      meta: { title: '智能体审核详情', auth: 'crae:agent:review:list', menu: false, activeMenu: '/aocx/review', tabMerge: 'activeMenu' },
    },
    {
      path: 'user-management',
      name: 'CraeAgentUserManagementIndex',
      component: () => import('@/views/aocx/user-management/index.vue'),
      meta: { title: '用户管理', icon: 'i-ant-design:user-outlined', auth: 'crae:agent:user:list' },
    },
    {
      path: 'creator-application',
      name: 'CraeAgentCreatorApplicationIndex',
      component: () => import('@/views/aocx/creator-application/index.vue'),
      meta: { title: '创作者申请', icon: 'i-ant-design:audit-outlined', auth: 'crae:agent:creator-application:list' },
    },
  ],
}

export default routes
